import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCategoryHivInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.85172 9.9643L4.84217 14.4L4 12.2113L6.51376 8.49108L6.8914 8L7.22502 8.50481L7.86099 9.50184L8 9.72277L7.85172 9.9643Z",
		fill: "current"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.1859 14.4005L11.9963 12.3628C12.0017 12.3487 12.0006 12.3335 11.9919 12.3204C11.6603 11.8374 6.67649 4.30152 6.56669 3.37681C6.77421 3.1886 7.1618 2.84374 8.11046 2.84374C8.77036 2.84374 9.26116 3.0091 9.5093 3.17555C9.66632 3.28107 9.73549 3.4758 9.6773 3.65531C9.49942 4.20361 8.73083 5.55804 8.3103 6.17488L9.33911 7.79802C9.33911 7.79802 10.7456 5.73754 10.7456 4.46906C10.7456 3.20057 9.68828 1.92446 9.14257 1.73734C8.59687 1.55023 7.25403 1.48169 6.7775 2.03434C6.19776 2.70666 5.55983 3.67815 5.60155 4.44839C5.64328 5.21862 5.85409 6.25865 6.65123 7.38244C7.44947 8.50624 11.1859 14.4016 11.1859 14.4016V14.4005Z",
		fill: "current"
	})]
});
export default SvgCategoryHivInformation;
